export class Event {

  private _type: string;
  private _payload: any;

  constructor(type: string, payload: any) {
    this._type = type;
    this._payload = payload;
  }

  get type(): string {
    return this._type;
  }

  get payload(): any {
    return this._payload;
  }
}